import { Component, OnInit, ViewChild, ViewEncapsulation, } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { FormGroup, FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from '@app/services/notification.service';


@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css'],
  animations: [
    trigger('footerPanelState', [
      state('false', style({ transform: 'translateY(270px)' })),
      state('true', style({ transform: 'translateY(0px)' })),
      transition('false => true', animate('400ms ease-in')),
      transition('true => false', animate('400ms ease-in')),
    ]),
    trigger('notificationPanelState', [
      state('false', style({ transform: 'translateY(-270px)' })),
      state('true', style({ transform: 'translateY(0px)' })),
      transition('false => true', animate('400ms ease-in')),
      transition('true => false', animate('400ms ease-in')),
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class LandingComponent implements OnInit {

  static readonly PANEL_WIDTH_OPEN: number = 0;
  static readonly PANEL_WIDTH_CLOSED: number = -300;
  static readonly TITLE_TEXT: string = 'Monex Customer Portal';
  // Properties.
  public title: string = LandingComponent.TITLE_TEXT;
  public userName: string = "";
  public password: string = "";
  public notificationText: string = "test - remove when finished";
  public isLoading: boolean = false;
  public isFooterShowing: boolean = false;
  public isNotificationPanelShowing: boolean = false;
  public passwordFieldHide: boolean = true;
  public hiddenPanelPosition: number = LandingComponent.PANEL_WIDTH_CLOSED;
  public hiddenPasswordPanelPosition: number = LandingComponent.PANEL_WIDTH_CLOSED;
  public hiddenSuccessPasswordEmailedPanelPosition: number = LandingComponent.PANEL_WIDTH_CLOSED;
  public hiddenUserIdSuccessPosition: number = LandingComponent.PANEL_WIDTH_CLOSED;
  public hiddenSetupSuccessPosition: number = LandingComponent.PANEL_WIDTH_OPEN;
  public failedLoginPanelPosition: number = LandingComponent.PANEL_WIDTH_CLOSED;
  public failedSetupPanelPosition: number = LandingComponent.PANEL_WIDTH_CLOSED;


  // Fields.  TODO: Check to see if these are necessary.
  public field1PlaceholderText: string = "Account Number";
  public field2PlaceholderText: string = "Last 4 Digits of SSN";
  public field3PlaceholderText: string = "Email Address";

  // Form groups.
  public landingFormGroup: FormGroup = new FormGroup({
    userIdFormControl: new FormControl('bjenkins@monex.com', Validators.compose([Validators.required, Validators.maxLength(45)])),
    passwordFormControl: new FormControl('Daniel01', [Validators.required, Validators.maxLength(45)]),
  });

  public resetPasswordFormGroup: FormGroup = new FormGroup({
    passwordResetFormControl: new FormControl('bjenkins@monex.com', Validators.compose([Validators.required, Validators.maxLength(45), Validators.minLength(5)])),
  });

  public forgotUserIdFormGroup: FormGroup = new FormGroup({
    forgotUserIdFormControl: new FormControl('170945660', Validators.compose([Validators.required, Validators.minLength(9), Validators.maxLength(9)])),
  });

  public setupFormGroup: FormGroup = new FormGroup({
    accountFormControl: new FormControl('170945660', Validators.compose([Validators.required, Validators.maxLength(9), Validators.minLength(9), Validators.pattern('[0-9]+')])),
    ssnFormControl: new FormControl('1892', Validators.compose([Validators.required, Validators.maxLength(4), Validators.minLength(4), Validators.pattern('[0-9]+')])),
    emailFormControl: new FormControl('bjenkins@monex.com', Validators.compose([Validators.required, Validators.maxLength(45), Validators.minLength(5), Validators.email])),
  });

  // Child components.

  // @ViewChild('landingPopover', { static: false })
  // public landingPopover: NgbPopover;
  @ViewChild('userNameInput', { static: false })
  public userNameInput: MatInput;
  

  // Inject modules.
  constructor(    
    private notificationService: NotificationService,        
  ) { }

  ngOnInit() {
    this.initControls();
    this.initListeners();
  }

  private initControls() { }

  private initListeners(): void {
    // Listens for notifications from other modules which will be displayed in the
    // sliding drop down panel.
    this.notificationService.getNotificationText().subscribe((text: string) => {
      if (text) {
        this.notificationText = text;
        this.showNotificationPanel();
      }
    });
  }

  public showNotificationPanel(): void {
    // if (this.landingPopover) {
    //   this.landingPopover.close();
    // }    
    this.isNotificationPanelShowing = true;
  }

  public hideNotificationPanel(): void {
    this.isNotificationPanelShowing = false;
  }

  public hideFooter(): void {
    this.isFooterShowing = false;
  }

}
